import Logo from "../logo/index"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faGithub,faYoutube } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';
import "./footer.css"

function Footer() {
  const { t } = useTranslation();

  const services = [
    { label: "Web Development", href: "/web" },
    { label: "UI/UX Design", href: "/designing" },
    { label: "Mobile App Development", href: "/mobile-development" },
    { label: "Cloud Infrastructure", href: "/cloud" },
    { label: "Blockchain Development", href: "/blockchain" },
  ];

  const companyLinks = [
    { label: t('portfolio'), href: "/portfolio" },
    { label: t('aboutus'), href: "/about-us" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Sitemap", href: "/sitemap.xml" },
    { label: "Cookie Settings", href: "#", action: "open-cookie-banner" },
  ];

  return (
    <footer className='footer-section text-light' aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="visually-hidden">BringIt Go Footer</h2>
      <div className="footer-grid">
        <section className="footer-company" aria-labelledby="footer-company-heading">
          <a className="footer-brand" href="/" aria-label="BringIt Go home">
            <Logo logotype="dark" />
          </a>
          <h3 id="footer-company-heading" className="footer-title">BringIt Go</h3>
          <p className="footer-description">
            BringIt Go builds scalable software solutions, from UI/UX and custom web development to cloud and blockchain integration. We help your business thrive.
          </p>
        </section>

        <nav className="footer-nav" aria-labelledby="footer-services-heading">
          <h3 id="footer-services-heading" className="footer-title">Services</h3>
          <ul className='footer-list'>
            {services.map((service) => (
              <li key={service.href}>
                <a className='footerlinks' href={service.href}>{service.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="footer-nav" aria-labelledby="footer-company-links-heading">
          <h3 id="footer-company-links-heading" className="footer-title">Company</h3>
          <ul className='footer-list'>
            {companyLinks.map((link) => (
              <li key={`${link.href}-${link.label}`}>
                {link.action === 'open-cookie-banner' ? (
                  <a
                    className='footerlinks'
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); window.dispatchEvent(new Event('open-cookie-banner')); }}
                  >
                    {link.label}
                  </a>
                ) : (
                  <a className='footerlinks' href={link.href}>{link.label}</a>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <section className="footer-contact-wrap" aria-labelledby="footer-contact-heading">
          <address className="footer-contact">
            <h3 id="footer-contact-heading" className="footer-title">{t('footer.letUsKnow')}</h3>
            <ul className='footer-list'>
              <li>
                <a className='footerlinks' href='mailto:info@bringitgo.tech?subject=Project Inquiry'>{t('footer.email')}</a>
              </li>
            </ul>
          </address>
          <nav aria-label="Social networks" className="footer-social">
            <h3 className="footer-title">{t('footer.socialNetworks')}</h3>
            <ul className="footer-social-list">
              <li>
                <a className='footerlinks' href='https://www.facebook.com/profile.php?id=100089307017324' target='_blank' rel='noreferrer' aria-label="BringIt Go on Facebook">
                  <FontAwesomeIcon icon={faFacebook} size="2x" />
                </a>
              </li>
              <li>
                <a className='footerlinks' href='https://github.com/bringitgo' target='_blank' rel='noreferrer' aria-label="BringIt Go on GitHub">
                  <FontAwesomeIcon icon={faGithub} size="2x" />
                </a>
              </li>
              <li>
                <a className='footerlinks' href='https://www.youtube.com/@BringitGoTech' target='_blank' rel='noreferrer' aria-label="BringIt Go on YouTube">
                  <FontAwesomeIcon icon={faYoutube} size="2x" />
                </a>
              </li>
            </ul>
          </nav>
        </section>
      </div>
      
      <div className="footer-bottom">
        <p>
          All rights reserved &copy; {new Date().getFullYear()} <strong>BringIt Go</strong>.
        </p>
      </div>
    </footer>
  )
}

export default Footer;